
import type { PropType } from 'vue'
import type { AuditItem } from '../../models'
import type { AuditObjectTypeConfigProvider } from '../../providers/interfaces'
import type { AuditItemDetailsMessages } from './item/details/audit-item-details.component.vue'
import { defineComponent } from 'vue'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import { ColorEnum } from '../../enums'
import { UiTooltip } from '../keen-ui'
import { EpbBadge, EpbButton, EpbText } from '../shared'
import TransitionSize from '../transition-size.component.vue'
import AuditDescription from './audit-description.component.vue'

export default defineComponent({
  name: 'AuditEntry',
  components: {
    AuditDescription,
    EpbBadge,
    EpbButton,
    EpbText,
    TransitionSize,
    UiTooltip,
  },
  props: {
    audit: {
      type: Object as PropType<AuditItem>,
      required: true,
    },
    expanded: Boolean,
    messages: {
      type: Object as PropType<AuditItemDetailsMessages>,
      required: true,
    },
  },
  setup(props) {
    const provider =
      CONTAINER.get<AuditObjectTypeConfigProvider>(TYPES.AuditObjectTypeConfigProvider)(
        props.audit.payload.objectType as string,
      ) ?? ({} as ReturnType<AuditObjectTypeConfigProvider>)

    const transformedProviderFieldNames = Object.entries(provider?.fieldNames).reduce(
      (obj: AuditItemDetailsMessages['fields'], [key, { label }]) => {
        obj[key] = label
        return obj
      },
      {},
    )

    const messages = {
      ...props.messages,
      fields: {
        ...transformedProviderFieldNames,
        ...props.messages.fields,
      },
    }

    return {
      baseClass: 'epb-audit-entry',
      ColorEnum,
      detailsComponent: provider?.detailsComponent,
      messages,
    }
  },
})
